import { Box, Checkbox, FormField, TextInput, Text } from '@acast/decibel';
import T from 'prop-types';
import React, { Component } from 'react';
import Modal from 'shared/components/modal';
import styled from 'styled-components';

const CheckboxContainer = styled(Box).attrs({
  alignItems: 'center',
  mt: 3,
  mb: 6,
  px: 2,
  py: 3,
})`
  background-color: #f9fafb;
  border: solid 1px #e3e4e7;
`;

class DeletionConfirmationDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
      isChecked: false,
    };
  }

  handleTextChange = ({ target: { value } }) => {
    this.setState({ text: value });
  };

  handleCheckboxChange = ({ target: { checked } }) => {
    this.setState({ isChecked: checked });
  };

  canConfirm = () => {
    return this.state.text.toLowerCase() === 'delete' && this.state.isChecked;
  };

  render() {
    return (
      <Modal
        title="Delete Show"
        onDismiss={this.props.onDismiss}
        dialog={
          <>
            <Text>
              You will not be able to recover your show after deleting it. Are you sure you want to
              delete <b>{this.props.show.name}</b>?
            </Text>
            <FormField label="Type delete and check the box to confirm">
              <TextInput
                placeholder="Type here"
                value={this.state.text}
                onChange={this.handleTextChange}
              />
            </FormField>
            <CheckboxContainer>
              <Checkbox
                id="checkbox-delete-confirmation"
                checked={this.state.isChecked}
                onChange={this.handleCheckboxChange}
                label="I understand that this action cannot be undone."
              />
            </CheckboxContainer>
          </>
        }
        actions={[
          { name: 'Cancel', value: false, variant: 'tertiary' },
          {
            name: 'Delete',
            value: true,
            variant: 'primary',
            intent: 'danger',
            disabled: !this.canConfirm(),
          },
        ]}
      />
    );
  }
}

DeletionConfirmationDialog.propTypes = {
  show: T.object,
  onDismiss: T.func.isRequired,
};

export default DeletionConfirmationDialog;
